import FloatingMenuPopup from '@/components/FloatingMenuPopup'
import { useIntegrationsModalOptional } from '@/components/IntegrationsModal/IntegrationsModalContext'
import DocumentsPickerDialog from '@/pages/Documents/DocumentsPickerDialog'
import { MAX_MESSAGE_ATTACHMENTS } from './aiAskBarLayoutConstants'
import AiAskBarAttachmentGalleryOverlay from './AiAskBarAttachmentGalleryOverlay'

export default function AiAskBarOverlays({
  vm,
  actions,
  onOpenConnections,
  attachmentGallerySenderLabel,
  attachmentGallerySubtitle,
  attachmentGallerySecondaryLine,
}) {
  const integrationsModal = useIntegrationsModalOptional()

  return (
    <>
      <FloatingMenuPopup
        open={vm.connectionsOpen}
        anchorEl={vm.connectionsButtonRef.current}
        onClose={() => vm.setConnectionsOpen(false)}
        items={vm.connectedAppsMenuItems}
        onItemSelect={(id) => {
          if (id === 'connected-app-manage') {
            if (onOpenConnections) onOpenConnections()
            else integrationsModal?.openIntegrations()
          }
        }}
      />
      <DocumentsPickerDialog
        open={vm.documentsPickerOpen}
        onClose={() => vm.setDocumentsPickerOpen(false)}
        onSelectDocuments={actions.handleSelectLibraryDocuments}
        maxSelectable={Math.max(0, MAX_MESSAGE_ATTACHMENTS - vm.attachments.length)}
      />
      <AiAskBarAttachmentGalleryOverlay
        vm={vm}
        attachmentGallerySenderLabel={attachmentGallerySenderLabel}
        attachmentGallerySubtitle={attachmentGallerySubtitle}
        attachmentGallerySecondaryLine={attachmentGallerySecondaryLine}
      />
    </>
  )
}
